import * as React from 'react';
import Modal from '../modal';
import * as Moment from 'moment';
import { Query, QueryCondition, QueryFilter } from '../../api/apiTypes';
import { DatePickerNoForm } from '../../../forms/informedv2/DatePicker';

interface DateRangeFilterModalProps {
    header: string;
    show: boolean;
    from: string;
    to: string;
    onApply: (event?) => void;
    onClose: () => void;
    onChange: (from, to, event?) => void;
    onClear?: (event?) => void;
}

interface GenericDateRangeFilterModalProps {
    query: Query<any>;
    member: string;
    header: string;
    onApply: (values?: QueryFilter[]) => void;
    onClear: (member: string) => void;
    onClose: () => void;
}

export const GetQueryFilter = (query: Query<any>, member: string, condition: QueryCondition): QueryFilter => {
    return query.Filters.find(filter => filter.Member === member && filter.Condition === condition);
}

export default class DateRangeModal extends React.Component<DateRangeFilterModalProps> {
    state = {
        from: this.props.from ? Moment(this.props.from) : null,
        to: this.props.to ? Moment(this.props.to) : null,
    };

    handleFromChange = (value, event?) => {
        const newFrom = Moment(value);
        this.setState({ from: newFrom }, () => {
            this.handleChange();
        });
    };

    handleToChange = (value, event?) => {
        const newTo = Moment(value);
        this.setState({ to: newTo }, () => {
            this.handleChange();
        });
    };

    handleChange = () => {
        const { from, to } = this.state;

        if (from && to) {
            const fromInclusive = from.startOf('day');
            this.props.onChange(fromInclusive, to);
        }
    };

    componentDidUpdate(prevProps) {
        if (this.props.from !== undefined &&
            (this.props.from !== prevProps.from || this.props.to !== prevProps.to)) {
            this.setState({
                from: this.props.from ? Moment(this.props.from) : null,
                to: this.props.to ? Moment(this.props.to) : null,
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.show !== this.props.show)
            return true;

        if (nextProps.header !== this.props.header)
            return true;

        if (nextProps.from !== undefined && (nextProps.from != nextState?.from?.format('YYYY-MM-DD') || nextProps.to != nextState?.to?.format('YYYY-MM-DD'))) {
            return true;
        }
        return false;
    }


    render() {
        const { header, show, onClose, onClear, onApply } = this.props;
        const { from, to } = this.state;
        const formattedFromDate = from ? from.format('YYYY-MM-DD') : null;
        const formattedToDate = to ? to.endOf('day').format('YYYY-MM-DD') : null;
        const handleApply = (event?) => onApply(event);
        const handleClear = onClear ? onClear : (event?) => {
            this.setState({ from: null, to: null }, () => {
                this.props.onChange(null, null);
                handleApply(event);
            });
        };
        const format = 'DD-MMM-YYYY';

        return (
            <Modal show={show} closeModalHandler={onClose} header={header}>
                <div className='modal-body'>
                    <div className='row'>
                        <div className='col-md-6 form-group'>
                            <label>From</label>
                            <DatePickerNoForm onChange={this.handleFromChange} value={formattedFromDate} className='form-control' placeholder={format} from={true} />
                        </div>
                        <div className='col-md-6 form-group'>
                            <label>To</label>
                            <DatePickerNoForm onChange={this.handleToChange} value={formattedToDate} className='form-control' placeholder={format} from={false} />
                        </div>
                    </div>
                </div>
                <div className='modal-footer'>
                    <button className='btn btn-primary' onClick={handleApply}>OK</button>
                    <button className='btn btn-danger' onClick={handleClear}>Clear</button>
                </div>
            </Modal>
        );
    }
}

export const GenericDateRangeModal = ({ query, member, header, onClose, onClear, onApply }: GenericDateRangeFilterModalProps): JSX.Element => {

    const fromFilterValue = GetQueryFilter(query, member, QueryCondition.GreaterThanOrEqual) || { Values: [] };
    const toFilterValue = GetQueryFilter(query, member, QueryCondition.LessThanOrEqual) || { Values: [] };

    const [from, setFrom] = React.useState<string>(fromFilterValue.Values[0]);
    const [to, setTo] = React.useState<string>(toFilterValue.Values[0]);

    return (<DateRangeModal
        header={header + ' Filter'}
        show={true}
        to={to}
        from={from}
        onChange={(_from, _to) => {
            setFrom(_from);
            setTo(_to);
        }}
        onApply={() => {
            onApply(
                [
                    { Member: member, Condition: QueryCondition.GreaterThanOrEqual, Values: !!from ? [from] : [] },
                    { Member: member, Condition: QueryCondition.LessThanOrEqual, Values: !!to ? [to] : [] }
                ]
            );
        }}
        onClear={() =>
            onClear(member)
        }
        onClose={onClose}
    />)
}
